import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function TrashIcon(props: any) {
	return (
		<Svg
			width={props.size}
			height={props.size}
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...props}
		>
			<Path
				d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z'
				fill={props.color}
			/>
		</Svg>
	);
}

export default TrashIcon;
